// ExpirationModal.jsx
import React, { useEffect, useState } from 'react';
import './ExpirationModal.css';

const getTokenExpiration = () => {
  const token = sessionStorage.getItem('token');
  if (!token) return null;

  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(window.atob(base64));
    const expirationRaw = payload.expiration_date;
    if (!expirationRaw) return null;

    const parts = expirationRaw.split(':');
    const timestampStr = parts[parts.length - 1];
    return new Date(Number(timestampStr) * 1000);
  } catch (error) {
    console.error('Erro ao decodificar token:', error);
    return null;
  }
};

const ExpirationModal = ({ onClose }) => {
  const [daysLeft, setDaysLeft] = useState(null);
  const [isExpired, setIsExpired] = useState(false);
  const [isAdm, setIsAdm] = useState(false);

  useEffect(() => {
    const admUser = sessionStorage.getItem('admUser');
    if (admUser === 'true') {
      setIsAdm(true);
      return;
    }
    const expirationDate = getTokenExpiration();
    if (!expirationDate) {
      setIsExpired(true);
      setDaysLeft(0);
      return;
    }

    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const expire = new Date(expirationDate.getFullYear(), expirationDate.getMonth(), expirationDate.getDate());

    const diffTime = expire.getTime() - today.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 0) {
      setIsExpired(true);
      setDaysLeft(0);
    } else if (diffDays <= 15) {
      setIsExpired(false);
      setDaysLeft(diffDays);
    } else {
      setIsExpired(false);
      setDaysLeft(null);
    }
  }, []);

  if (isAdm) return null;

  const whatsappNumber = '5514998421100';
  const message = encodeURIComponent('Olá! Meu plano expirou e gostaria de renovar o acesso aos cálculos.');
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${message}`;
  const hotmartLink = 'https://ewersontx.kpages.online/software-renania-a044d70f-701d-4269-8b89-cb929224516d';

  if (!isExpired && daysLeft === null) return null;

  return (
    <div className="expiration_modal">
      <div className={isExpired ? 'expired_box' : 'warning_box'}>
        {isExpired ? (
          <>
            <h2>🚫 Plano expirado!</h2>
            <p>Seu plano está vencido e os cálculos não funcionarão até ser renovado.</p>
          </>
        ) : (
          <>
            <h2>⚠️ Atenção!</h2>
            <p>
              Seu plano expira em <strong>{daysLeft}</strong> dia{daysLeft > 1 ? 's' : ''}.
            </p>
            <p>Renove agora para não perder acesso aos cálculos.</p>
          </>
        )}

        <div className="button_group">
          <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="whatsapp_button">
            💬 Renovar via WhatsApp
          </a>
          <a href={hotmartLink} target="_blank" rel="noopener noreferrer" className="hotmart_button">
            💳 Renovar via Hotmart
          </a>
        </div>

        {!isExpired && (
          <button className="close_button" onClick={onClose}>
            ✖ Fechar
          </button>
        )}
      </div>
    </div>
  );
};

export default ExpirationModal;
